// Declare your constants
export const STATIC_STRINGS = {
  DASHBOARD: "Dashboard",
  ASSESSMENTS: "Your Assessments",
  ORG_SETTINGS: "Organisation Settings",
  LOG_OUT: "Logout",
  CREATE_NEW_ASSESSMENT_TITLE: "Create New Assessment",
  CREATE_NEW_ASSESSMENT_DESC:
    "Create a new assessment to evaluate your candidates.",

  // Table Headers
  TABLE_HEADERS: {
    ASSESSMENT_NAME: "Assessment Name",
    JOB_ROLE: "Job Role",
    EXPERIENCE: "Experience",
    CANDIDATES: "Candidates",
    CANDIDATE: "Candidate",
    DEADLINE: "Deadline",
    STATUS: "Status",
    DATE_CREATED: "Date Created",
    ACTIONS: "Actions",
  },
  STATUS: {
    PAUSED: "PAUSED",
    ACTIVE: "ACTIVE",
    DRAFT: "DRAFT",
  },
  MENU_ITEMS: {
    EDIT: "Edit",
    DELETE: "Delete Assessment",
    CLONE: "Clone Assessment",
    PAUSED: "Pause Assessment",
    MAKE_ACTIVE: "Make Assessment Active",
  },
  N_A: "N/A",
  VIEW: "View",
  VIEW_REPORT: "View Report",
  RETRY: "Retry",
  ERROR_MESSAGE: "Oops! Something went wrong.",
  ASSESSMENT_API_ERROR: "Unable to fetch assessments. Please try again later.",
  REPORTS_API_ERROR:
    "Unable to fetch assessment report. Please try again later.",
  CANDIDATES_API_ERROR:
    "Unable to fetch candidates report. Please try again later.",
  ASSESSMENT_SEARCH_PLACEHOLDER: "Search Assessments",
  CANDIDATE_SEARCH_PLACEHOLDER: "Search Candidates",
  ASSESSMENT_DETAILS: "Assessment Details",
  TOPIC_DISTRIBUTION: "Topic Distribution",
  PREVIEW_QUESTIONS: "Preview Questions",
  SCHEDULE_TIMINGS: "Schedule Timings",
  ADD_CANDIDATES: "Add Candidates",
  BACK: "Back",
  PREVIOUS_STEP: "Previous Step",
  NEXT_STEP: "Next Step",
  FORM_VALIDATION_ERROR: "Error: Required fields are missing.",
  FINISH: "Finish",
  ASSESSMENT_TITLE_PLACEHOLDER: "SDE3 Assessment",
  UNTITLED_ASSESSMENT: "Untitled Assessment",
  TITLE_FOR_ASSESSMENT: "Title For Assessment",
  JOB_DESIGNATION: "Job Designation",
  JOB_ROLE: "Job Role",
  EXPERIENCE_RANGE: "Experience Range",
  SKILLS_TITLE: "Skills you want to assess",
  TAKE_AI_HELP: "Take help of AI",
  SKILLS_PLACEHOLDER: "Type the skills you want to add",
  ASK_AI_PLACEHOLDER: "What type of profile you want to hire for?",
  ASK_AI: "Ask AI",
  ESTIMATED_ASSESSMENT_TIME: "Estimated Assessment Time : ",
  ADD_SKILLS: "Add Skills",
  SR_NO: "S.No.",
  TOPIC: "Topic",
  QUESTION_TYPE: "Question Type",
  DIFFICULTY_LEVEL: "Difficulty Level",
  NUMBER_OF_QUESTIONS: "Number Of Questions",
  ADDITIONAL_REQUIREMENTS: "Additional Requirements (If Any)",
  MCQ: "MCQ",
  TRUE_FALSE: "TRUE/FALSE",
  SUBJECTIVE: "SUBJECTIVE",
  CODE: "CODE",
  QUESTION_TYPES_DROPDOWN: ["MCQ", "TRUE/FALSE", "SUBJECTIVE", "CODE"],
  ADD_TYPE: "Add Type",
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
  ADD_NEW_QUESTION: "Add New Question",
  SCORE: "Score",
  ESTIMATED_TIME: "Estimated Time",
  QUESTIONS_PREVIEW: "Questions Preview",
  PREVIOUS_QUESTION: "Previous Question",
  NEXT_QUESTION: "Next Question",
  DELETE: "Delete",
  REGENERATE_QUESTION: "Regenerate Question",
  ASSESSMENT_DELETE_HEADING: "Delete Assessment",
  ASSESSMENT_DELETE_DESC: "Are you sure want to delete this assessment?",
  CANCEL: "Cancel",
  PROCESSING: "Processing",
  MONTHS: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  TIME_PERIOD: "Time Period",
  DURATION: "Duration",
  HOURS: "Hours",
  DAYS: "Days",
  questionTypes: [
    "Text",
    "Number",
    "Email",
    "Url",
    "Mobile",
    "File",
    "Boolean",
    "Single Select",
    "Multi Select",
  ],
  ASSIGNMENT_SCHEDULE: "Assignment Schedule",
  ASSESSMENT_TIME:
    "Set up a start and end time for the assessment. (Indian Standard Time IST)",
  START_TIME: "Start Time",
  END_TIME: "End Time",
  DURATION_PHRASE:
    "The test will be accessible for this period after the email is sent.",
  PROCTORING: "Would you like to enable proctoring for the test?",
  YES: "Yes",
  NO: "No",
  QUESTIONS_AT_START:
    "Select the questions you would like to ask from candidate at the start of assessment:",
  PHONE_NUMBER: "Phone Number",
  LINKEDIN: "LinkedIn",
  GITHUB: "GitHub",
  CURRENT_LOCATION: "Current Location",
  HOW_SOON: "How soon can you join",
  CURRENT_CTC: "Current CTC",
  EXPECTED_CTC: "Expected CTC",
  CUSTOM_QUESTION_PLACEHOLDER: "Enter a custom question",
  ADD_CUSTOM_QUESTION: "Add A Custom Question",
  TYPE_OF_QUESTION: "Type of Question",
  TOOLTIP_MESSAGES: {
    EMAIL_REMAINDER_DISABLED:
      "You cannot send reminders to students who have already attempted.",
    EMAIL_REMAINDER: "Send Remainder Email",
    SELECT_COLUMNS: "Select Columns",
    ADD_CANDIDATES: "Add Candidates",
    DOWNLOAD_REPORT: "Download Overall Report",
    EDIT_ASSESSMENT: "Edit Assessment",
    COPY_ASSESSMENT_LINK: "Copy Assessment Link",
    SHOW_FILTERS: "Show Filters",
  },
  COMPLETED: "Completed",
  ADD_CANDIDATE_HEADING:
    "You can add candidates by uploading Excel or CSV File or add them manually with their Name and Email.",
  UPLOAD_HEADING: "Upload Excel or CSV File",
  UPLOAD_SUBHEADING:
    "Select Excel or CSV File here to upload. Please check the format it should be in <name, email> pair.",
  DOWNLOAD_FORMAT: "Download Format",
  FILE_FORMAT_ROWS: [
    ["name1", "name1@gmail.com"],
    ["name2", "name2@gmail.com"],
  ],
  CSV_CONTENT: "data:text/csv;charset=utf-8,",
  DOWNLOAD_FILE_NAME: "candidate_format.csv",
  UPLOADED_SUCCESSFULLY: "uploaded successfully!",
  SELECTED: "Selected",
  UPLOAD_FILE: "Upload File",
  SELECT_FILE: "Select File",
  ADD_EMAIL_MANUALLY: "Add Email Manually",
  CANDIDATE_NAME: "Candidate Name",
  NAME_PLACEHOLDER: "John Doe",
  EMAIL: "Email",
  EMAIL_PLACEHOLDER: "johndoe@gmail.com",
  ADD_EMAIL: "Add Email",
  PREVIEW_EMAIL: "Preview or Edit Email Body",
  EMAIL_BODY: `Subject: Assessment Invitation : [Assessment Title]

Dear [Candidate Name],

You have been invited to complete the [Assessment Title] as part of our selection process. Please find the details below:

Position: [Job Title]
Date & Time: [Date & Time]
Assessment Link: [Assessment Link]

Kindly complete the assessment within the given timeframe. If you have any questions, feel free to reach out.

Thank You.`,
  EMAIL_REGEX: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,

  NOT_STARTED: "Not Started",
  FILTERS: "Filters",
  TOTAL_MARKS: "Total Marks",
  PROGRESS: "Progress",
  USER_STATUS: "User Status",
  TRUST_SCORE: "Trust Score",
  STRONG_AREAS: "Strong Areas",
  STRONG_AREAS_PLACEHOLDER: "Strong Areas...",
  RESET_ALL: "Reset All",
  APPLY: "Apply",
  PROGRESS_OPTIONS: ["Not Started", "In Progress", "Completed"],
  STATUS_OPTIONS: ["Shortlisted", "Rejected", "Hired"],
  CONFIRM: "Confirm",
  RESET: "Reset",
};
